"use client";

import useAgent from "@/features/home/hooks/useAgent";
import { IAgentFilters } from "@/interfaces/IAgentData";
import { createContext, ReactNode, useContext } from "react";

const AgentContext = createContext<ReturnType<typeof useAgent> | undefined>(
  undefined,
);

AgentContext.displayName = "AgentContext";

interface IContextProps extends Pick<IAgentFilters, "sort_option"> {
  children: ReactNode;
}

export function AgentProvider(props: IContextProps) {
  const context = useAgent({ sort_option: props.sort_option });
  return (
    <AgentContext.Provider value={context}>
      {props.children}
    </AgentContext.Provider>
  );
}

export function useAgentProvider() {
  const context = useContext(AgentContext);
  return { ...context };
}
